export default "__VITE_ASSET__32e4af9f__"